/* eslint-disable import/prefer-default-export */
import { takeLatest, put, all } from 'redux-saga/effects' // eslint-disable-line
import editRegionalProjectActions, {
    editRegionalProjectTypes,
} from '../../../../redux/donneesSocioEconomique/donneesRegionalProject/editRegionalProject'
import getRegionalProjectActions from '../../../../redux/donneesSocioEconomique/donneesRegionalProject/getRegionalProject'
import { Put } from '../../../../serveur/axios'
import alertActions from '../../../../redux/alert'

function* editRegionalProjectSagas({ response }) {
    try {
        const { intl } = response
        delete response.intl
        const res = yield Put(`regional-project/${response.id}`, response)
        const { history } = response.props

        if (res.status === 200 || res.status === 201) {
            yield all([
                yield put(
                    getRegionalProjectActions.getRegionalProjectRequest()
                ),
                yield put(
                    editRegionalProjectActions.editRegionalProjectSuccess()
                ),
                yield put(
                    alertActions.alertShow(true, {
                        onConfirm: false,
                        warning: false,
                        info: false,
                        error: false,
                        success: true,
                        message: intl.formatMessage({
                            id: 'successSagaMessage',
                        }),
                        title: intl.formatMessage({
                            id: 'successSagaTitle',
                        }),
                    })
                ),
            ])
            history.push(
                '/formulaires/gestion-des-données/socioéconomiques',
                response.values
            )
        } else {
            yield put(
                editRegionalProjectActions.editRegionalProjectFailure(res)
            )
        }
    } catch (error) {
        yield put(editRegionalProjectActions.editRegionalProjectFailure(error))
    }
}

export function* editRegionalProjectSaga() {
    yield takeLatest(
        editRegionalProjectTypes.EDIT_REGIONAL_PROJECT_REQUEST,
        editRegionalProjectSagas
    )
}
